import React from 'react'
import './header2.css';
export default function Header2() {   
    function CustomLink({ href, children }) {
        const path = window.location.href; 
        const isActive = path.includes(href);
        return (
            <li className={isActive ? "active" : ""}>
                <a href={href} className={isActive ? "active" : ""}>
                    {children}
                </a>
            </li>
        );
    }
    
const handleclass =()=>{

}
  return (
    <>
    <section id='header2-section'>
        <div id='header2-cont'>
            <ol onMouseLeave={handleclass}>
                <CustomLink href='/newsportal?category=indianhistory'>Indian History</CustomLink>
                <CustomLink href='/newsportal?category=untoldhistory'>Untold History</CustomLink>
                <CustomLink href='/newsportal?category=mysteries'>Mysteries</CustomLink>
                <CustomLink href='/newsportal?category=movies'>Movies</CustomLink>
                <CustomLink href='/newsportal?category=sports'>Sports</CustomLink>
                <CustomLink href='/newsportal?category=india'>India</CustomLink>
                <CustomLink href='/newsportal?category=world'>World</CustomLink>
                <CustomLink href='/newsportal?category=tech'>Tech</CustomLink>
                <CustomLink href='/newsportal?category=lifestyle'>Life style</CustomLink>
                <CustomLink href='/newsportal?category=health'>Health & Wealth</CustomLink>
            </ol>
        </div>    
        <hr/>
    </section> 
    </>
  )
}
